import { MentionTypes } from '@lyearn/lygo-blocks';
import eventConfig from '@/modules/content/modules/event/config';
import useEvents from '@/modules/events/hooks/useEvents';
import { EventUnion, MentionEntityTypeEnum } from '@/types/schema';

import { ALLOWED_EVENT_STATUS } from '../../consts';
import { MentionsData } from '../../types';
import BaseEventItem from './BaseEventItem';

const useEventSearch = ({ searchString }: { searchString?: string }) => {
  const filters = {
    name: searchString,
    status: ALLOWED_EVENT_STATUS,
  };
  const { events, isFetching } = useEvents({ filters });

  // TODO @HimanshuSahu31 refactor explicit type cast
  return { data: events as EventUnion[], fetching: isFetching };
};

const EventMention = {
  getMentionNodeAttrs: (item: EventUnion) => ({
    href: eventConfig.routes.details(item.id),
    name: item.name,
    id: item.id,
    type: MentionTypes.Event,
  }),
  useSearch: useEventSearch,
  getInitialItems: (items?: MentionsData) => items?.events,
  BaseItem: BaseEventItem,
  type: MentionEntityTypeEnum.Event,
};

export default EventMention;
